/* Timbrica — /light-pollution-map ("карта засветки" / dark-sky finder).
 *
 * David Lorenz's VIIRS world atlas as a Leaflet overlay (proxied same-origin for
 * RU). Click anywhere for the exact zenith sky brightness in mag/arcsec2
 * (decoded server-side). The atlas author asks NOT to quote an exact Bortle, so
 * we lead with mag/arcsec2 + a plain-language sky label and show Bortle only as
 * a clearly-rough reference.
 */
(function () {
  'use strict';
  var C = window.LP_CFG || {};
  var T = C.t || {}, API = C.api || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

  function skyClass(m) {
    if (m >= 21.9) return { b: '1', key: 'sky_excellent', mw: 'mw_easy' };
    if (m >= 21.7) return { b: '2', key: 'sky_truly_dark', mw: 'mw_easy' };
    if (m >= 21.5) return { b: '3', key: 'sky_rural', mw: 'mw_easy' };
    if (m >= 21.0) return { b: '4', key: 'sky_rural_sub', mw: 'mw_faint' };
    if (m >= 20.4) return { b: '4–5', key: 'sky_suburban', mw: 'mw_faint' };
    if (m >= 19.4) return { b: '5–6', key: 'sky_bright_sub', mw: 'mw_no' };
    if (m >= 18.4) return { b: '7', key: 'sky_suburban_urban', mw: 'mw_no' };
    return { b: '8–9', key: 'sky_city', mw: 'mw_no' };
  }
  function skyColor(m) { return m >= 21.7 ? '#1b5e20' : m >= 21.0 ? '#558b2f' : m >= 20.4 ? '#9e9d24' : m >= 19.4 ? '#ef6c00' : m >= 18.4 ? '#d84315' : '#b71c1c'; }

  var map = null, lp = null;
  function initMap() {
    if (!window.L || !$('lpMap')) return;
    var tile = C.tile || {};
    map = L.map('lpMap', { center: [C.home.lat, C.home.lon], zoom: C.home.z, minZoom: 2, maxZoom: 11, worldCopyJump: true });
    // Подложка через общий примитив: второй адрес (наш прокси <-> прямой CDN)
    // и честная строка, если не ответил ни один. Здесь стоял пустой
    // .on('tileerror', function () {}) — крючок был, внутри ничего, и
    // упавший хост давал ЧЁРНЫЙ прямоугольник без слова объяснения.
    if (window.__mapTiles) {
      window.__mapTiles.base(L, map, null, { slug: 'light-pollution-map', style: tile.style || 'dark', credit: tr('map_attr'), opts: { maxZoom: 19 }, text: tile.offline });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(L, map, tr('map_attr'));
    }
    lp = L.tileLayer(C.lpTile, { maxNativeZoom: 8, maxZoom: 11, opacity: 0.72, className: 'lp-overlay' }).addTo(map);
    map.on('click', function (ev) { query(ev.latlng.lat, ev.latlng.lng); });
  }

  // Подпись точки — общий модуль GeoCity (public/js/geo-city.js): город на
  // языке страницы, румб и расстояние («↗ Город · 42 км»).
  function geoFill(lat, lon, elId, ok) {
    if (!window.GeoCity) return;
    GeoCity.fill(elId, lat, lon, { empty: '—', ok: ok });
  }

  function query(lat, lon) {
    var pop = L.popup({ className: 'lp-pop', maxWidth: 240 }).setLatLng([lat, lon]).setContent('<div class="lp-pop-load">' + tr('loading') + '</div>').openOn(map);
    fetch(API.value + '?lat=' + lat.toFixed(4) + '&lon=' + lon.toFixed(4))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.none || d.mpsas == null) { pop.setContent('<div class="lp-pop-load">' + tr('no_data') + '</div>'); return; }
        var sc = skyClass(d.mpsas);
        pop.setContent(
          '<div class="lp-pop-mag" style="color:' + skyColor(d.mpsas) + '">' + d.mpsas.toFixed(2) + ' <small>' + tr('mag_unit') + '</small></div>' +
          '<div class="lp-pop-cls">' + tr(sc.key) + '</div>' +
          '<div class="lp-pop-mw">🌌 ' + tr(sc.mw) + '</div>' +
          '<div class="lp-pop-b">' + tr('bortle_approx') + ' ' + sc.b + ' <span title="' + tr('bortle_note') + '">ⓘ</span></div>' +
          '<div id="lpGeo" style="font-size:12px;opacity:.72;margin-top:5px"></div>'
        );
        geoFill(lat, lon, 'lpGeo', function () { return map.hasLayer(pop); });
        ae('feature_use', { slug: 'light-pollution-map', feature: 'query' });
      })
      .catch(function () { pop.setContent('<div class="lp-pop-load">' + tr('no_data') + '</div>'); ae('tool_error', { slug: 'light-pollution-map', where: 'value' }); });
  }

  function locate() {
    // A bare `return` here was a literally silent dead click: the button
    // did nothing and said nothing. __geo.notify explains why and reports it.
    if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
    var b = $('lpLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) { map.setView([pos.coords.latitude, pos.coords.longitude], 8); query(pos.coords.latitude, pos.coords.longitude); ae('feature_use', { slug: 'light-pollution-map', feature: 'locate' }); if (b) b.disabled = false; },
      function (err) { if (b) b.disabled = false; if (window.__geo) __geo.notify(err); }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  function boot() {
    try { window.Timbrica3D && window.Timbrica3D.init && window.Timbrica3D.init('light-pollution-map'); } catch (e) {}
    initMap();
    var lb = $('lpLocate'); if (lb) lb.addEventListener('click', locate);
    var op = $('lpOpacity'); if (op) op.addEventListener('input', function () { if (lp) lp.setOpacity(op.value / 100); });
    ae('tool_complete', { slug: 'light-pollution-map' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
